export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-06-13 at 22.29.00.6d32c650.jpeg";